// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"9dba817e","453":"d97cbc27","500":"452bce20"}[chunkId] + ".chunk.js";
};